'use client'

import { toast } from 'react-toastify'
import {
  Button,
  Input,
  Spinner,
  SpinnerOverlay,
  SpinnerSubtext,
  ToastProvider,
  Avatar,
  AvatarItem,
  AvatarFallback
} from '@teqplay/ui'

export {
  Button,
  Input,
  Spinner,
  SpinnerOverlay,
  SpinnerSubtext,
  ToastProvider,
  Avatar,
  AvatarItem,
  AvatarFallback
}

// Temporary Custom hook to match the teqplay useToast interface
export const useToast = () => {
  return {
    toast: ({
      title,
      variant
    }: {
      title: string
      variant?: 'success' | 'error' | 'info' | 'warning'
    }) => {
      switch (variant) {
        case 'success':
          toast.success(title)
          break
        case 'error':
          toast.error(title)
          break
        case 'warning':
          toast.warn(title)
          break
        case 'info':
          toast.info(title)
          break
        default:
          toast(title)
      }
    }
  }
}
